"use client";

import React from "react";
import { Building2, Clock, MapPin, PenTool } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const leftFeatures = [{
  icon: Building2,
  title: "RESIDENTIAL CLEARING",
  description: "Witness the transformation of overgrown backyard thickets into pristine, usable landscapes ready for your next outdoor living project."
}, {
  icon: Clock,
  title: "RAPID RESTORATION",
  description: "Our high-efficiency mulching equipment turns years of neglect into a clean slate in just hours, preserving your valuable time."
}];
const rightFeatures = [{
  icon: MapPin,
  title: "ACREAGE RECLAMATION",
  description: "From dense brush to park-like settings, we specialize in reclaiming lost acreage while maintaining the health of your soil."
}, {
  icon: PenTool,
  title: "PRECISION MULCHING",
  description: "Our process creates a nutrient-rich layer of mulch that prevents erosion and suppresses regrowth, blending science with land care."
}];
export default function WhyChooseUs() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="257819" id="before-after-gallery" className="bg-background text-foreground ![padding:-25px_0px_0px_0px]">
      <div className="relative bg-secondary text-secondary-foreground rounded-b-3xl overflow-hidden pt-24 lg:pt-32 pb-0">
        
        {}
        <div className="absolute top-12 left-1/2 -translate-x-1/2 w-full text-center pointer-events-none select-none opacity-[0.05] z-0" aria-hidden="true">
          <span className="text-[5rem] md:text-[10rem] lg:text-[14rem] font-default font-bold leading-none tracking-widest text-transparent whitespace-nowrap" style={{
          WebkitTextStroke: "2px currentColor"
        }}>
            TRANSFORMATIONS
          </span>
        </div>

        <div className="container relative z-10 ![margin:0px_0px_0px_70px] ![padding:4px_0px_4px_0px]">
          {}
          <div ref={headerRef} className={cn("text-center mb-8 lg:mb-12 transition-all duration-1000 ease-out", headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
            <h2 className="text-2xl md:text-4xl font-default font-semibold uppercase tracking-[0.15em] text-secondary-foreground">Explore Our Full Range <br />of Expert Services</h2>
          </div>

          {}
          <div className="grid grid-cols-1 lg:grid-cols-[1fr_auto_1fr] gap-12 lg:gap-8 items-center">
            
            {}
            <div ref={leftRef} className={cn("flex flex-col gap-12 lg:gap-20 transition-all duration-1000 delay-200 ease-out", leftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12")}>
              {leftFeatures.map((item, i) => <div data-index={i} key={i} className="flex gap-5 max-w-md mx-auto lg:mx-0">
                  <div className="shrink-0 mt-1">
                    <item.icon className="w-7 h-7 text-primary stroke-[1.5]" />
                  </div>
                  <div>
                    <h3 className="text-base md:text-lg font-default font-semibold uppercase tracking-wider mb-3 text-secondary-foreground">
                      {item.title}
                    </h3>
                    <p className="text-secondary-foreground/80 text-sm md:text-base leading-relaxed font-default">
                      {item.description}
                    </p>
                  </div>
                </div>)}
            </div>

            {}
            <div ref={imageRef} className="relative h-[400px] w-full flex justify-center items-center transition-all duration-1000 delay-300 ease-out group opacity-100 translate-y-0 !p-0 !m-0 sm:h-[500px] lg:h-[700px] lg:w-[400px] xl:w-[500px]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/land_transformation_comparison.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/land_transformation_comparison.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/land_transformation_comparison.png-wvc-sizes" alt="Before and after land clearing transformation" className="object-contain object-bottom max-h-full w-auto drop-shadow-2xl rounded-lg transition-transform duration-500 group-hover:scale-105 !p-0" loading="lazy" />
            </div>

            {}
            <div ref={rightRef} className={cn("flex flex-col gap-12 lg:gap-20 transition-all duration-1000 delay-400 ease-out", rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12")}>
              {rightFeatures.map((item, i) => <div data-index={i} key={i} className="flex gap-5 max-w-md mx-auto lg:mx-0">
                  <div className="shrink-0 mt-1">
                    <item.icon className="w-7 h-7 text-primary stroke-[1.5]" />
                  </div>
                  <div>
                    <h3 className="text-base md:text-lg font-default font-semibold uppercase tracking-wider mb-3 text-secondary-foreground">
                      {item.title}
                    </h3>
                    <p className="text-secondary-foreground/80 text-sm md:text-base leading-relaxed font-default">
                      {item.description}
                    </p>
                  </div>
                </div>)}
            </div>

          </div>
        </div>
      </div>
    </section>;
}